import React from "react";
import ArticlePage from "../ArticlePage";

const Invest = () => (
  <ArticlePage
    title="Invest"
    subtitle="Invest"
    leadImage="/img/culture/invest.jpg"
    body={[
      "Investing tools and market data every young creator should be comfortable with. These two links are our recommended starting points \u2014 free market snapshots at Google Finance and deeper research tools at Fidelity.",
      "Nothing on this page is financial advice. Please do your own research and consult a licensed adviser before making decisions with real money.",
    ]}
    sources={[
      {
        brand: "Google Finance",
        title: "Live quotes, portfolios and news, free",
        host: "google.com/finance",
        href: "https://www.google.com/finance/beta",
        accent: "#1a73e8",
      },
      {
        brand: "Fidelity Research",
        title: "Deep research, screeners and analyst reports",
        host: "digital.fidelity.com",
        href: "https://digital.fidelity.com/prgw/digital/research/src",
        accent: "#379844",
      },
    ]}
  />
);

export default Invest;
